import { fg } from '@atlaskit/platform-feature-flags';

import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForManualFeatureOnboarding(context: EditionAwarenessContextType) {
	const { edition, isInTrial, invoiceableStatus, userRoles, lastKnownTrial, product } = context;

	if (!fg('manual_trial_w_payment_details_elgibility_check')) {
		return false;
	}

	return Boolean(
		product === 'confluence' &&
			(edition === 'standard' || edition === 'premium') &&
			isInTrial &&
			invoiceableStatus === 'INVOICEABLE' &&
			userRoles?.includes('SITE_ADMIN') &&
			lastKnownTrial?.trialType === 'MANUAL_TRIAL',
	);
}
